<template>
    <div>
        <b-row>
            <b-col>
                <div class="mt-1">
                    <span class="pagination-indicator">{{ pagination.currentFirstItem }}-{{ pagination.currentLastItem }} of {{ pagination.maxPage }} page</span>
                    
                    <b-pagination
                        hide-goto-end-buttons
                        align="left"
                        size="md"
                        class="custom-pagination-arrow-only mb-0 ml-2"
                        :total-rows="(pagination.totalPerPage > 0) ? pagination.maxPage * pagination.totalPerPage : 1"
                        :limit="(pagination.totalPerPage > 0) ? 3 : 1"
                        :per-page="pagination.totalPerPage"
                        @change="paginate">
                    </b-pagination>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ChannelMatrixPagination",
    data() {
        return {
            startList: 1,
            endList: 10,
            maxPage: 10
        };
    },
    computed: {
        ...mapState("reportsChannel", ["pagination", "list", "param"])
    },
    methods: {
        paginate: async function(page) {
            let param = this.param.param;
            this.$store.commit("reportsChannel/loading", true);
            await this.$store
                .dispatch("reportsChannel/getList", {
                    param,
                    page
                })
                .then(() => {
                    this.$store.commit("reportsChannel/loading", false);
                });
        }
    }
}
</script>
